import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { Router } from '@angular/router';
import { BaseSubMaintenanceController } from '../_base/BaseSubMaintenanceController';
import { AmbitAddressListMaintenanceDto } from './AmbitAddressListMaintenanceDto';
import { AmbitAddressItemMaintenanceDto } from './AmbitAddressItemMaintenanceDto';

@Injectable()
export class AmbitAddressSubmaintenanceController extends BaseSubMaintenanceController<AmbitAddressListMaintenanceDto, AmbitAddressItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {
        super(http, alertService, translateService, loadingService, router, "ambit/address");
    }

    public getResourceRoot(): string {
        return "AMBIT.ADDRESS";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/securityandnotifications/ambit/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}
